import { render, staticRenderFns } from "./quest-onboarding.vue?vue&type=template&id=456bf561"
import script from "./quest-onboarding.vue?vue&type=script&lang=js"
export * from "./quest-onboarding.vue?vue&type=script&lang=js"
import style0 from "./quest-onboarding.vue?vue&type=style&index=0&id=456bf561&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports